module.exports = __webpack_public_path__ + "img/flaminiaGiorda.3a92b3e3.jpg";